<template>
  <div class="page">
    <Head :headTitle="headTitle" />
    <div class="b-container">
      <div class="con-l">
        <div class="mod1 flex flex-v">
          <div class="b-pub-tt flex">
            <span class="bt">企业信息</span>
          </div>
          <div class="iesjjs">
            <div class="scroll-list flex-1 flex flex-v">
              <div class="row-t">
                <div style="width: 33%">企业名称</div>
                <div style="width: 10%">联系人</div>
                <div style="width: 20%">联系电话</div>
                <div style="width: 35%">产品类别</div>
              </div>
              <div class="scrollbb">
                <vue-seamless-scroll
                  :data="factoryList"
                  :class-option="scrollOption"
                  class="scrollb"
                >
                  <div class="scrollbox flex-1">
                    <div
                      class="row"
                      v-for="(item, index) in factoryList"
                      :key="index"
                    >
                      <div style="width: 33%" :title="item.enterprise">
                        {{ item.enterprise }}
                      </div>
                      <div style="width: 10%" :title="item.principal">
                        {{ item.principal }}
                      </div>
                      <div style="width: 20%" :title="item.photo">
                        {{ item.photo }}
                      </div>
                      <div style="width: 35%" :title="item.product">
                        {{ item.category }}
                      </div>
                    </div>
                  </div>
                </vue-seamless-scroll>
                <span class="linebg"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="mod2 flex flex-v">
          <div class="b-pub-tt flex">
            <span class="bt">采购数据</span>
          </div>
          <div class="iesjjs">
            <div class="scroll-list flex-1 flex flex-v iesjjs">
              <div class="row-t">
                <div style="width: 9%">区县</div>
                <div style="width: 28%">采购人</div>
                <div style="width: 27%">商品名称</div>
                <div style="width: 9%">数量</div>
                <div style="width: 9%">单价</div>
                <div style="width: 15%">交易金额</div>
              </div>
              <div class="scrollbb">
                <vue-seamless-scroll
                  :data="tecssLnst"
                  :class-option="scrollOption"
                  class="scrollb"
                >
                  <div class="scrollbox flex-1">
                    <div
                      class="row"
                      v-for="(item, index) in tecssLnst"
                      :key="index"
                    >
                      <div style="width: 9%" :title="item.prefecture">
                        {{ item.prefecture }}
                      </div>
                      <div style="width: 30%" :title="item.purchasingAgent">
                        {{ item.purchasingAgent }}
                      </div>
                      <div style="width: 25%" :title="item.productName">
                        {{ item.productName }}
                      </div>
                      <div style="width: 9%" :title="item.count">
                        {{ item.count }}
                      </div>
                      <div style="width: 9%" :title="item.unitPrice">
                        {{ item.unitPrice }}
                      </div>
                      <div style="width: 15%" :title="item.transactionAmount">
                        {{ item.transactionAmount }}
                      </div>
                    </div>
                  </div>
                </vue-seamless-scroll>
                <span class="linebg"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="mod3 flex flex-v">
          <div class="b-pub-tt flex">
            <span class="bt">入驻企业</span>
          </div>
          <div class="scroll-list flex-1 flex flex-v">
            <div class="row-t">
              <div style="width: 50%">企业名称</div>
              <div style="width: 10%">负责人</div>
              <div style="width: 20%">电话</div>
              <div style="width: 20%">入驻类型</div>
            </div>
            <div class="scrollbb">
              <vue-seamless-scroll
                :data="yuslist"
                :class-option="scrollOption"
                class="scrollb"
              >
                <div class="scrollbox flex-1">
                  <div class="row" v-for="item in yuslist" :key="item.id">
                    <div style="width: 50%" :title="item.enterprise">
                      {{ item.enterprise }}
                    </div>
                    <div style="width: 10%" :title="item.principal">
                      {{ item.principal }}
                    </div>
                    <div style="width: 20%" :title="item.photo">
                      {{ item.photo }}
                    </div>
                    <div style="width: 20%" :title="item.settleType">
                      {{ item.settleType }}
                    </div>
                  </div>
                </div>
              </vue-seamless-scroll>
              <span class="linebg"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="con-c flex flex-v relative">
        <div class="mod-cen">
          <div class="cen-menu">
            <!-- <span class="lk cur">智慧城市</span>
              <span class="lk">数字乡村振兴</span>
              <span class="lk">黄花菜产业云平台</span>
              <span class="lk">智慧文旅</span> -->
          </div>
          <div class="cen-list">
            <div class="item item1">
              <h6 class="title">市场与客户管理</h6>
              <div class="txt">
                <p>市场和客户需求应该始终作为整个供应链的开端和导向。</p>
              </div>
              <div class="line"></div>
              <div class="circle">
                <div class="w1"></div>
                <div class="w2"></div>
                <div class="w3"></div>
                <div class="w4"></div>
              </div>
            </div>
            <div class="item item2">
              <h6 class="title">产品开发管理</h6>
              <div class="txt">
                <p>
                  供应链管理的这个过程是讲要和客户及供应商共同开发产品，并把产品投放市场。
                </p>
              </div>
              <div class="line"></div>
              <div class="circle">
                <div class="w1"></div>
                <div class="w2"></div>
                <div class="w3"></div>
                <div class="w4"></div>
              </div>
            </div>
            <div class="item item3">
              <h6 class="title">计划与需求管理</h6>
              <div class="txt">
                <p>
                  计划和需求管理不仅仅指下达定单指令，它还包括设计经济订货批量(EOQ)，在较小化的配送成本的基础上满足客户需求等
                </p>
              </div>
              <div class="line"></div>
              <div class="circle">
                <div class="w1"></div>
                <div class="w2"></div>
                <div class="w3"></div>
                <div class="w4"></div>
              </div>
            </div>
            <div class="item item4">
              <h6 class="title">采购与供应管理</h6>
              <div class="txt">
                <p>
                  供应商与制造商之间需要经常进行有关成本、作业计划、质量控制等信息的交流与沟通，以保持信息的一致性和准确性。
                </p>
              </div>
              <div class="line"></div>
              <div class="circle">
                <div class="w1"></div>
                <div class="w2"></div>
                <div class="w3"></div>
                <div class="w4"></div>
              </div>
            </div>
            <div class="item item5">
              <h6 class="title">生产与运营管理</h6>
              <div class="txt">
                <p>
                  做好生产与运营管理生产组织、生产计划、和生产控制工作等管理工作，以实现预期生产的品种、质量、产量和生产成本目标。
                </p>
              </div>
              <div class="line"></div>
              <div class="circle">
                <div class="w1"></div>
                <div class="w2"></div>
                <div class="w3"></div>
                <div class="w4"></div>
              </div>
            </div>
            <div class="item item6">
              <h6 class="title">仓储与物流管理</h6>
              <div class="txt">
                <p>
                  如何提高库存的周转率和资金利用率，降低原材料、半成品、产成品的库存和流通费用，是仓储与物流管理需要解决的问题
                </p>
              </div>
              <div class="line"></div>
              <div class="circle">
                <div class="w1"></div>
                <div class="w2"></div>
                <div class="w3"></div>
                <div class="w4"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="con-r">
        <div class="mod4 flex flex-v">
          <div class="b-pub-tt flex">
            <span class="bt">{{ subtitleList.fourmoudle }}</span>
          </div>
          <div class="detail flex-11">
            <div class="col">
              <div class="b-smtit flex">
                <span class="bt">{{ yearGDP }}</span>
                <!-- <span class="bt">规上工业产值</span> -->
              </div>
              <div class="chart" ref="chart9"></div>
            </div>
            <div class="col">
              <div class="b-smtit flex">
                <span class="bt">{{ keyProject }}</span>
              </div>
              <div class="chart" ref="chart10"></div>
            </div>
            <div class="col">
              <div class="b-smtit flex">
                <span class="bt">{{ onlineIndustry }}</span>
              </div>
              <div class="chart" ref="chart11"></div>
            </div>
            <div class="col">
              <div class="b-smtit flex">
                <span class="bt">{{ countyIncome }}</span>
              </div>
              <div class="chart" ref="chart12"></div>
            </div>
          </div>
        </div>

        <div class="mod6">
          <div class="b-pub-tt flex">
            <span class="bt">产品图片</span>
          </div>
          <div class="swiper-container swiper-container2">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/one.jpg"
                  alt=""
                />
                <img
                  style="margin-top: 20%"
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/two.jpg"
                  alt=""
                />
                <img
                  style="margin-top: 20%"
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/nine.jpg"
                  alt=""
                />
              </div>

              <div class="swiper-slide">
                <img
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/three.jpg"
                  alt=""
                />
                <img
                  style="margin-top: 20%"
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/four.jpg"
                  alt=""
                />
                <img
                  style="margin-top: 20%"
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/ten.jpg"
                  alt=""
                />
              </div>
              <div class="swiper-slide">
                <img
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/five.jpg"
                  alt=""
                />
                <img
                  style="margin-top: 20%"
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/six.jpg"
                  alt=""
                />
                <img
                  style="margin-top: 20%"
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/ele.jpg"
                  alt=""
                />
              </div>

              <div class="swiper-slide">
                <img
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/seven.jpg"
                  alt=""
                />
                <img
                  style="margin-top: 20%"
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/eight.jpg"
                  alt=""
                />
                <img
                  style="margin-top: 20%"
                  src="https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/twelve.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-bg">
        <bgAnimateVue />
      </div>
    </div>
  </div>
</template>
  
  <script>
// import 'assets/css/style.css'
import axios from "axios";
import Head from "@/components/head_big.vue";
let Echarts = require("echarts/lib/echarts");
import { loopShowTooltip } from "../assets/js/tooltip-auto-show-vue.js";
// import axios from 'axios'
import bgAnimateVue from "@/components/bg_animate.vue";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  data() {
    return {
      headTitle: "祁东供应链管理系统",
      education: {}, //教育情况
      investment: {}, //投资情况
      treatment: {}, //医疗情况
      income: {}, //"人均可再支配收入"
      xAxisData: [], //横坐标的值
      seriesData: [], //series的data值
      environment: {}, //环境指数
      fineAir: {}, //优良天气质量数
      yearAir: {}, //年度空气质量天数
      centerInfo: {}, //中间部分信息
      yearGDP: "", //年度GDP
      keyProject: "", //重点项目投资额
      onlineIndustry: "", //"线上工业销售额"
      countyIncome: "", //"县城公共财政预算收入"
      workManagement: {}, //"政务工作办理情况"
      takeNumber: {}, //取号情况
      waitingTime: {}, //大厅综合等待时间
      swiper1: [],
      swiper2: [],
      subtitleList: [],
      scrollList: [
        {
          title: "县城共出口交通事故",
          num: "1",
          level: "紧急",
        },
        {
          title: "食品加工厂消防事故",
          num: "2",
          level: "紧急",
        },
        {
          title: "县卫生院卫生事故",
          num: "1",
          level: "紧急",
        },
        {
          title: "村桥段边坡",
          num: "1",
          level: "紧急",
        },
      ],

      tootipTimer5: "",
      tootipTimer6: "",

      tootipTimer7: "",

      tootipTimer8: "",
      chart9: null,
      tootipTimer9: "",
      chart10: null,
      tootipTimer10: "",
      chart11: null,
      tootipTimer11: "",
      chart12: null,
      tootipTimer12: "",
      city: "",
      country: "",
      temperature: 0,
      description: "",
      humidity: 0,
      windSpeed: 0,
      factoryList: [
        {
          enterprise: "湖南大三湘茶油股份有限公司",
          principal: "冯阳进",
          photo: "15874156683",
          category: "茶油、洗护用品",
        },
        {
          enterprise: "湖南省广林农业科技开发有限公司",
          principal: "刘经耀",
          photo: "18907342732",
          category: "香肠、花酒、洗护用品",
        },
        {
          enterprise: "绿色田园（衡阳）农业发展有限公司",
          principal: "蒋双超",
          photo: "15580221314",
          category: "野枇杷果（代用茶）",
        },
        {
          enterprise: "衡阳市宝盖绿康生态农业科技发展有限公司",
          principal: "刘启",
          photo: "13807475564",
          category: "茶叶",
        },
        {
          enterprise: "衡阳市天品花汇茶业有限公司",
          principal: "廖富生",
          photo: "13762442388",
          category: "茉莉花茶",
        },
        {
          enterprise: "衡南县犇犇生态农牧有限公司",
          principal: "胡余梅",
          photo: "18975408328",
          category: "豆制品",
        },
        {
          enterprise: "衡阳市漂木文化有限公司",
          principal: "夏云丽",
          photo: "13027460033",
          category: "特色小吃",
        },
        {
          enterprise: "衡南县竣斌养殖种植专业合作社",
          principal: "胡峻斌",
          photo: "15173417766",
          category: "枇杷蜜饯",
        },
        {
          enterprise: "湖南省展望生物科技发展有限公司",
          principal: "胡祥文",
          photo: "13973442900",
          category: "菜籽油",
        },
        {
          enterprise: "衡阳罗氏粉业有限公司",
          principal: "罗平",
          photo: "18692082711",
          category: "米粉系列",
        },
        {
          enterprise: "衡南世源农业发展有限公司",
          principal: "罗淑君",
          photo: "15675479303",
          category: "优质米",
        },
        {
          enterprise: "衡阳市福颖农业科技发展有限公司",
          principal: "江初颖",
          photo: "15886444929",
          category: "无花果干",
        },
        {
          enterprise: "衡阳美怡佳食品有限公司",
          principal: "周飞飞",
          photo: "18073415659",
          category: "糖果",
        },
        {
          enterprise: "湖南角山米业有限责任公司",
          principal: "杨智良",
          photo: "13974758292",
          category: "粮食",
        },
        {
          enterprise: "衡阳德源莲业有限责任公司",
          principal: "王候",
          photo: "13975489696",
          category: "乌莲",
        },
        {
          enterprise: "衡阳县龙青农耕农副产品专业合作社",
          principal: "杨莎",
          photo: "13789358131",
          category: "面条",
        },
        {
          enterprise: "衡阳县石荷岭绿色食品有限公司",
          principal: "李云良",
          photo: "15342449257",
          category: "竹笋",
        },
        {
          enterprise: "湖南陈海龙生态农业发展有限公司",
          principal: "刘彩凤",
          photo: "13926094531",
          category: "茶叶、米粉",
        },
        {
          enterprise: "湖南省谷一酒业有限公司",
          principal: "唐力铭",
          photo: "17347097999",
          category: "湖芝酒",
        },
        {
          enterprise: "湖南渣江米粉产业有限公司",
          principal: "谢利华",
          photo: "13548523800",
          category: "米粉",
        },
        {
          enterprise: "衡阳安合农业服务有限公司",
          principal: "张美玲",
          photo: "13875618564",
          category: " ",
        },
        {
          enterprise: "衡阳市天天见梳篦实业有限公司",
          principal: "刘吉华",
          photo: "18873430100",
          category: "梳篦",
        },
        {
          enterprise: "湖南金芙农业科技有限公司",
          principal: "郑婷",
          photo: "17397349606",
          category: "羊肚菌",
        },
        {
          enterprise: "湖南省森成果林科技有限公司",
          principal: "方紫蓝",
          photo: "13857966525",
          category: "水果",
        },
        {
          enterprise: "衡阳志宏农业发展股份有限公司",
          principal: "陈修武",
          photo: "13713829133",
          category: "水果、红薯粉",
        },
        {
          enterprise: "湖南省嘉穗农业发展有限公司",
          principal: "朱东阳",
          photo: "13575256278",
          category: "粮食",
        },
        {
          enterprise: "湖南仲军农业发展股份有限公司",
          principal: "周建科",
          photo: "18573171991",
          category: "大米",
        },
        {
          enterprise: "湖南湘宏食品股份有限公司",
          principal: "尹恒姣",
          photo: "13650746354",
          category: "腊鱼、腊肉加工农产品",
        },
        {
          enterprise: "湖南衡岳中药饮片有限公司",
          principal: "康诗林",
          photo: "13789376777",
          category: "中药材",
        },
        {
          enterprise: "湖南好堂客食品有限公司",
          principal: "郭建良",
          photo: "13923487535",
          category: "豆腐花",
        },
        {
          enterprise: "湖南奇山农业发展有限公司",
          principal: "阳山奇",
          photo: "18973473536",
          category: "亚奇红柚",
        },
        {
          enterprise: "衡山佳人文化传媒有限公司",
          principal: "刘彻",
          photo: "18942025588",
          category: "木瓜条、黄瓜皮等加工农产品",
        },
        {
          enterprise: "湖南聚味堂食品有限公司",
          principal: "张璐",
          photo: "15273143159",
          category: "蔬菜、预制菜",
        },
        {
          enterprise: "衡东县庆发食品有限公司",
          principal: "秦庆权",
          photo: "13973146492",
          category: "蔬菜",
        },
        {
          enterprise: "湖南省美衡食品有限公司",
          principal: "康华彬",
          photo: "15307474247",
          category: "休闲食品",
        },
        {
          enterprise: "湖南衡东县衡金优质农产品有限公司",
          principal: "龙金平",
          photo: "13907471818",
          category: "禽蛋",
        },
        {
          enterprise: "衡东胜春绿色科技有限公司",
          principal: "颜美东",
          photo: "13875706414",
          category: "粮食",
        },
        {
          enterprise: "湖南彭妹子食品有限公司",
          principal: "张伶果",
          photo: "18607345292",
          category: "畜禽",
        },
        {
          enterprise: "衡阳丰食园粮油食品贸易有限公司",
          principal: "彭建国",
          photo: "13762472768",
          category: "粮食",
        },
        {
          enterprise: "湖南湘勇盛农产品开发有限公司",
          principal: "武曙阳",
          photo: "13387478208",
          category: "豆制品",
        },
        {
          enterprise: "湖南御园湘食生态农业发展有限公司",
          principal: "苏园芳",
          photo: "18975430663",
          category: "休闲食品",
        },
        {
          enterprise: "湖南巨帆食品有限公司",
          principal: "匡晓奕",
          photo: "18973315980",
          category: "休闲食品",
        },
        {
          enterprise: "衡东湘里湘亲绿色农业发展有限公司",
          principal: "周鑫",
          photo: "17377853352",
          category: "休闲食品",
        },
        {
          enterprise: "湖南省一诺农林有限公司 ",
          principal: "肖丽亚",
          photo: "13927495822",
          category: "油料",
        },
        {
          enterprise: "祁东县农业发展有限公司",
          principal: "谭伟",
          photo: "13170334333",
          category: "蔬菜、其它",
        },
        {
          enterprise: "湖南新发食品有限公司",
          principal: "肖捷",
          photo: "19918688881",
          category: "蔬菜",
        },
        {
          enterprise: "湖南有吉食品有限公司",
          principal: "万基荣",
          photo: "17369387777",
          category: "蔬菜",
        },
        {
          enterprise: "湖南吉祥食品有限公司",
          principal: "谢群亚",
          photo: "15377474777",
          category: "蔬菜、粮食、其它",
        },
        {
          enterprise: "湖南龙旺食品有限公司",
          principal: "李海玉",
          photo: "17680266686",
          category: "蔬菜、粮食",
        },
        {
          enterprise: "祁东农交汇食品有限公司",
          principal: "谢铁军",
          photo: "15673453333",
          category: "其它",
        },
        {
          enterprise: "湖南劲松食品股份有限公司",
          principal: "肖劲松",
          photo: "13974776090",
          category: "蔬菜、粮食",
        },
        {
          enterprise: "湖南省中黄农业科技发展有限公司",
          principal: "周红军",
          photo: "13317473633",
          category: "蔬菜、其它",
        },
        {
          enterprise: "湖南雁隆食品有限责任公司",
          principal: " 唐飞",
          photo: "18229220923",
          category: "蔬菜",
        },
        {
          enterprise: "常宁市湖广熟惠农服务有限责任公司",
          principal: "徐鸿鸣",
          photo: "15873434366",
          category: "常宁无渣生姜",
        },
        {
          enterprise: "湖南省天塘湖生态茶叶有限责任公司",
          principal: "邓远坤",
          photo: "13873417776",
          category: "常宁塔山茶",
        },
        {
          enterprise: "常宁市大禾坪农林发展有限公司",
          principal: "万友芝",
          photo: "18175833645",
          category: '"休闲食品、再生稻米、土鸡蛋',
        },
        {
          enterprise: "湖南佳鑫农林牧生态开发有限公司",
          principal: "吴清香",
          photo: "18821920658",
          category: "常宁塔山茶红茶、绿茶；",
        },
        {
          enterprise: '"湖南辣过瘾农业科技有限公司',
          principal: "",
          photo: "",
          category: "",
        },
        {
          enterprise: "湖南心海圆农业发展股份有限公司",
          principal: "梁义民",
          photo: "13387346668",
          category: "粮食",
        },
        {
          enterprise: "湖南新食康农业发展有限公司",
          principal: "郑薇",
          photo: "18774241829",
          category: "粮食",
        },
        {
          enterprise: "湖南神犁农业科技股份有限公司",
          principal: "郑青华",
          photo: "18373449962",
          category: "茶叶",
        },
        {
          enterprise: "湖南水木芙蓉茶业有限公司",
          principal: "齐瑜",
          photo: "18973471200",
          category: "茶叶",
        },
        {
          enterprise: "湖南胡家园茶业有限公司",
          principal: "严军",
          photo: "13973427611",
          category: "茶叶",
        },
        {
          enterprise: "湖南神农国油生态农业发展有限公司",
          principal: "罗浩",
          photo: "13786137194",
          category: "茶油",
        },
        {
          enterprise: "湖南军浩绿色食品股份有限公司",
          principal: "邹康建",
          photo: "18175829263",
          category: "蔬菜",
        },
        {
          enterprise: "湖南湘当靓食品科技有限公司",
          principal: "贺佐兴",
          photo: "15570971097",
          category: "其他",
        },
        {
          enterprise: "湖南荣创黄花菜食品有限公司",
          principal: "谭小兵",
          photo: "15074788326",
          category: "蔬菜",
        },
        {
          enterprise: "湖南淑沁食品有限公司",
          principal: "曾庆仁",
          photo: "15574721999",
          category: "蔬菜",
        },
        {
          enterprise: "湖南焱燚生态农业开发股份有限公司",
          principal: "王小珉",
          photo: "17397222229",
          category: "其他",
        },
        {
          enterprise: "耒阳市供销大盛电商服务有限公司",
          principal: "陈明龙",
          photo: "15616681046",
          category: "其他",
        },
        {
          enterprise: " 衡阳市南岳怡绿有机茶开发有限公司",
          principal: "彭其舟",
          photo: "13873406707",
          category: "茶叶",
        },
        {
          enterprise: "衡阳乡乐缘食品有限公司",
          principal: "阳锡文",
          photo: "15873421881",
          category: "粮食",
        },
        {
          enterprise: "衡阳市南岳区西岭有机茶业有限公司",
          principal: "李国军",
          photo: "18169340198",
          category: "茶叶",
        },
        {
          enterprise: "衡阳衡韵商贸有限公司",
          principal: "刘新根",
          photo: "18975420777",
          category: "其他",
        },
        {
          enterprise: "衡阳市雁城食品有限公司",
          principal: "刘巧",
          photo: "13873479621",
          category: "中药材",
        },
        {
          enterprise: "湖南华易盛农业发展有限公司简介",
          principal: "谢蕉岭",
          photo: "13873449300",
          category: "蔬果脆",
        },
        {
          enterprise: "李氏紫竹林食品有限公",
          principal: "何擂军",
          photo: "18273418333",
          category: "米粉",
        },
        {
          enterprise: "湖南一豆食品科技有限公司",
          principal: "张美郡",
          photo: "18173476589",
          category: "豆制品",
        },
        {
          enterprise: "湖南康洁食品科技发展有限公司",
          principal: "罗四清",
          photo: "13875674388",
          category: "米粉",
        },
        {
          enterprise: "衡阳市星乐农业科技有限公司",
          principal: "李富强",
          photo: "13974756101",
          category: "干果、饮料",
        },
        {
          enterprise: "湖南新丰生态农业股份有限公司",
          principal: "曾娜",
          photo: "18974725855",
          category: "",
        },
        {
          enterprise: "衡阳市君玲传统食品科技发展有限责任公司",
          principal: "罗飞燕",
          photo: "18175836987",
          category: "",
        },
        {
          enterprise: "衡阳市望夫湖农业发展有限公司",
          principal: "刘运来",
          photo: "15973489958",
          category: "",
        },
        {
          enterprise: "衡阳香樟苑农业综合开发有限公司",
          principal: "李焕涛",
          photo: "15386013623",
          category: "",
        },
        {
          enterprise: "湖南省兆祥生态农业科技有限公司",
          principal: "朱剑",
          photo: "18973456133",
          category: "",
        },
        {
          enterprise: "衡阳市力丰现代农业发展有限公司",
          principal: "罗红姣",
          photo: "18617061206",
          category: "金甲吉萝卜等 ",
        },
        {
          enterprise: "衡阳市衡洲农业综合开发有限公司",
          principal: "黄建刚",
          photo: "13875723873",
          category: "农产品、水果（高岭橘柚）",
        },
        {
          enterprise: "衡阳市波哥农场食品有限公司",
          principal: "周波",
          photo: "13638443707",
          category: "鱼丸子，鸡萝卜",
        },
        {
          enterprise: "衡阳市楚芳现代农业发展有限公司",
          principal: "刘春艳",
          photo: "15096059770",
          category: "农产品、蔬菜",
        },
        {
          enterprise: "衡阳领航种养殖专业合作社",
          principal: "刘佳",
          photo: "13467768787",
          category: "农产品、蔬菜、熟制食品",
        },
        {
          enterprise: "衡阳市金雁粮食购销有限公司",
          principal: "王奇峰",
          photo: "18674722998",
          category: "粮食",
        },
        {
          enterprise: "湖南誉湘龙农业科技股份有限公司",
          principal: "许建辉",
          photo: "13875691827",
          category: "粮食",
        },
        {
          enterprise: "衡阳市惠农农业科技发展有限公司",
          principal: "罗波",
          photo: "15773488689",
          category: "蔬菜",
        },
        {
          enterprise: "湖南华达田园生态农业股份有限公司",
          principal: "王小会",
          photo: "18507342666",
          category: "蔬菜",
        },
        {
          enterprise: '"湖南亿湘农生态',
          principal: "",
          photo: "",
          category: "",
        },
        {
          enterprise: '农业发展有限公司"',
          principal: "肖胜辉",
          photo: "15386037690",
          category: "蔬菜",
        },
        {
          enterprise: "湖南金林食品科技有限责任公司",
          principal: "肖金林",
          photo: "13723841298",
          category: "面条",
        },
        {
          enterprise: "衡阳水耕鱼种植养殖农民专业合作社",
          principal: "吴明敏",
          photo: "19918160288",
          category: "鱼",
        },
        {
          enterprise: "湖南明升新能源有限公司",
          principal: "刘代城",
          photo: "15271530822",
          category: "生物质天然气工程",
        },
        {
          enterprise: "汐烁科技有限公司",
          principal: "袁威",
          photo: "18996532950",
          category: "全生物质降解农膜",
        },
        {
          enterprise: "衡南县紫东农机农技专业合作社",
          principal: "谢满初",
          photo: "13575108876",
          category: "秸秆资源综合利用",
        },
        {
          enterprise: "衡阳红坊食品有限公司",
          principal: "康乐",
          photo: "15973412726",
          category: "红米、芝麻糖",
        },
        {
          enterprise: "古汉中药有限公司",
          principal: "曾 婧",
          photo: "13873410900",
          category:
            "人参茯苓膏/茯苓山楂膏/甘姜饮/参杞桑枣茶/桑莓杞菊茶/九制黄精片",
        },
        {
          enterprise: "衡阳鑫鸿生态农业有限公司",
          principal: "罗美银",
          photo: "18973458368",
          category: "畜禽",
        },
        {
          enterprise: "衡阳建华生态有限公司",
          principal: "陶建华",
          photo: "18173475093",
          category: "畜禽",
        },
        {
          enterprise: "衡阳益民生态农业开发有限公司",
          principal: "蒋治",
          photo: "13873401671",
          category: "畜禽",
        },
      ],
      tecssLnst: [
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县白地市镇中学",
          productName: "祁东县黄花源大米25kg/袋",
          count: "36",
          unitPrice: "115",
          transactionAmount: "4140",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县白地市镇中学",
          productName: "祁东县黄花源稻花香米5kg/包",
          count: "1",
          unitPrice: "65.8",
          transactionAmount: "65.8",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县白地市镇中学",
          productName: "祁东县喜百岁玉米胚芽油5L/桶",
          count: "67",
          unitPrice: "86.8",
          transactionAmount: "5815.6",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "麻阳蓝凤凰红糖2KG",
          count: "2",
          unitPrice: "100",
          transactionAmount: "200",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "平江誉湘精品白糖500G",
          count: "10",
          unitPrice: "9.8",
          transactionAmount: "98",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "湘潭县木耳1斤",
          count: "6",
          unitPrice: "55",
          transactionAmount: "330",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县自然资源局机关",
          productName: "祁东县黄花源香软粘米15kg/袋",
          count: "100",
          unitPrice: "90",
          transactionAmount: "9000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县自然资源局机关",
          productName: "祁东县黄花源香软粘米10kg/袋",
          count: "100",
          unitPrice: "60",
          transactionAmount: "6000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县粮市镇中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "120",
          unitPrice: "115",
          transactionAmount: "13800",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县行政审批服务局机关",
          productName: "祁东县黄花源大米25kg/袋",
          count: "87",
          unitPrice: "115",
          transactionAmount: "10005",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县四明山国家森林公园管理处",
          productName: "祁东县黄花源稻花香米5kg/包",
          count: "152",
          unitPrice: "65.8",
          transactionAmount: "10001.6",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县步云桥镇人民政府",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "286",
          unitPrice: "35",
          transactionAmount: "10010",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县灵官镇人民政府",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "50",
          unitPrice: "35",
          transactionAmount: "1750",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县灵官镇人民政府",
          productName: "祁东县黄花源香软粘米15kg/袋",
          count: "38",
          unitPrice: "90",
          transactionAmount: "3420",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县灵官镇人民政府",
          productName: "祁东县喜百岁山茶籽油1L/瓶",
          count: "35",
          unitPrice: "138",
          transactionAmount: "4830",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "祁东县 金泰-青蛙王子籼米小袋20斤",
          count: "50",
          unitPrice: "75",
          transactionAmount: "3750",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "祁东县 金泰-青蛙王子籼米小袋20斤",
          count: "130",
          unitPrice: "75",
          transactionAmount: "9750",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县永昌街道永昌中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "261",
          unitPrice: "115",
          transactionAmount: "30015",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县河洲镇人民政府",
          productName: "祁东县 金泰-青蛙王子籼米小袋20斤",
          count: "75",
          unitPrice: "75",
          transactionAmount: "5625",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县河洲镇人民政府",
          productName: "金泰-生态香米小袋10斤",
          count: "75",
          unitPrice: "60",
          transactionAmount: "4500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县鸟江镇中学",
          productName: "祁东县 金泰-桃香米籼米大袋50斤",
          count: "84",
          unitPrice: "120",
          transactionAmount: "10080",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "金泰-生态香米小袋10斤",
          count: "40",
          unitPrice: "60",
          transactionAmount: "2400",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县风石堰镇人民政府",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "40",
          unitPrice: "115",
          transactionAmount: "4600",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县风石堰镇人民政府",
          productName: "金泰-金泰环农家米小袋10斤",
          count: "52",
          unitPrice: "90",
          transactionAmount: "4680",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县风石堰镇人民政府",
          productName: "金泰-红色香粘籼米大袋50斤",
          count: "52",
          unitPrice: "110",
          transactionAmount: "5720",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县白地市镇人民政府",
          productName: "祁东粒粒馋再生稻5KG",
          count: "300",
          unitPrice: "50",
          transactionAmount: "15000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "衡东杨桥麸子肉500g/袋（杨桥皇贡）",
          count: "15",
          unitPrice: "40",
          transactionAmount: "600",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "衡东杨桥乡里腊肉500g/袋（杨桥皇贡）",
          count: "6",
          unitPrice: "40",
          transactionAmount: "240",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "衡东神州食曲神曲饼（米饼）248g/包",
          count: "20",
          unitPrice: "12",
          transactionAmount: "240",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "三樟黄贡椒950g（杨桥皇贡）",
          count: "5",
          unitPrice: "23",
          transactionAmount: "115",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "永顺县花椒调料卤料配料红花椒500克/袋",
          count: "5",
          unitPrice: "69",
          transactionAmount: "345",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "平江县农家自制调味酱誉湘贡椒牛肉酱268G",
          count: "5",
          unitPrice: "23",
          transactionAmount: "115",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "永顺县芙蓉行原色古法冰糖600g",
          count: "5",
          unitPrice: "19",
          transactionAmount: "95",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "望城县日晟隆八角500g",
          count: "5",
          unitPrice: "68",
          transactionAmount: "340",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "望城县日晟隆桂皮500g",
          count: "5",
          unitPrice: "21",
          transactionAmount: "105",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "望城县日晟隆香叶500g",
          count: "5",
          unitPrice: "25",
          transactionAmount: "125",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "茶陵县农家自制烟熏腊肠500g",
          count: "6",
          unitPrice: "80",
          transactionAmount: "480",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "辰溪县烟熏黄牛肉腊肉饲草放养牛农家青壮牛肉500g",
          count: "6",
          unitPrice: "149",
          transactionAmount: "894",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "城步县红薯妹-农家猪血丸子350g*1包（2个）",
          count: "10",
          unitPrice: "25",
          transactionAmount: "250",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "永兴高泽 永兴冰糖橙精品果 18斤装/箱",
          count: "2",
          unitPrice: "168",
          transactionAmount: "336",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "沅陵土家王腊猪脚肉 4斤左右每只 按实际称重计算500克",
          count: "8",
          unitPrice: "65",
          transactionAmount: "520",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName:
            "湖南特产好呷湘香辣口味牛肉酱拌面拌饭辣椒酱茶陵孜然口味黄牛肉120g*2瓶",
          count: "4",
          unitPrice: "32.9",
          transactionAmount: "131.6",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "永顺县黄牛肉腊牛肉干500g装黄牛腊肉",
          count: "6",
          unitPrice: "128",
          transactionAmount: "768",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "湖南湘西川湘一家农家土猪肉腊排骨500g/袋",
          count: "10",
          unitPrice: "52",
          transactionAmount: "520",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "新邵县腊兔子1只装",
          count: "6",
          unitPrice: "100",
          transactionAmount: "600",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "宜章县土里巴吉无硝腊肠500g/袋 (广式腊肠微甜精装版)",
          count: "6",
          unitPrice: "78",
          transactionAmount: "468",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "湖南省永顺县杂粮五谷糍粑270g*3袋装",
          count: "10",
          unitPrice: "26.9",
          transactionAmount: "269",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "茶陵县小潭油炸米粉块4KG装",
          count: "2",
          unitPrice: "105",
          transactionAmount: "210",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "永顺县羊肚菌200g干菌子炖煮煲汤特食材",
          count: "6",
          unitPrice: "360",
          transactionAmount: "2160",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县医疗保障局机关",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "143",
          unitPrice: "35",
          transactionAmount: "5005",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县粮市镇人民政府",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "63",
          unitPrice: "35",
          transactionAmount: "2205",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县粮市镇人民政府",
          productName: "祁东县黄花源香软粘米15kg/袋",
          count: "10",
          unitPrice: "90",
          transactionAmount: "900",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县粮市镇人民政府",
          productName: "祁东县黄花源大米25kg/袋",
          count: "60",
          unitPrice: "115",
          transactionAmount: "6900",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县鸟江镇人民政府",
          productName: "金泰-生态香米小袋10斤",
          count: "219",
          unitPrice: "60",
          transactionAmount: "13140",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县第三人民医院",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "100",
          unitPrice: "35",
          transactionAmount: "3500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县第三人民医院",
          productName: "祁东县黄花源香软粘米10kg/袋",
          count: "25",
          unitPrice: "60",
          transactionAmount: "1500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县交通运输综合行政执法大队",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "200",
          unitPrice: "35",
          transactionAmount: "7000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县交通运输综合行政执法大队",
          productName: "祁东县黄花源干黄花菜260g礼盒装/份",
          count: "67",
          unitPrice: "45",
          transactionAmount: "3015",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县中医医院",
          productName: "金泰-生态香米小袋10斤",
          count: "167",
          unitPrice: "60",
          transactionAmount: "10020",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东经济开发区管理委员会",
          productName: "金泰-生态香米小袋10斤",
          count: "84",
          unitPrice: "60",
          transactionAmount: "5040",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县凤歧坪乡人民政府",
          productName: "祁东县黄花源香软粘米10kg/袋",
          count: "84",
          unitPrice: "60",
          transactionAmount: "5040",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东经济开发区归阳工业园",
          productName: "金泰-生态香米小袋10斤",
          count: "167",
          unitPrice: "60",
          transactionAmount: "10020",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县审计局",
          productName: "祁东县喜百岁玉米胚芽油5L/桶",
          count: "58",
          unitPrice: "86.8",
          transactionAmount: "5034.4",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县砖塘镇包圣殿中学",
          productName: "金泰-红色香粘籼米大袋50斤",
          count: "91",
          unitPrice: "110",
          transactionAmount: "10010",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县蒋家桥镇第二中学",
          productName: "祁东粒粒馋晚籼米25KG",
          count: "90",
          unitPrice: "115",
          transactionAmount: "10350",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县蒋家桥镇人民政府",
          productName: "祁东县喜百岁玉米胚芽油5L/桶",
          count: "72",
          unitPrice: "86.8",
          transactionAmount: "6249.6",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县蒋家桥镇人民政府",
          productName: "祁东县黄花源再生稻5kg/包",
          count: "73",
          unitPrice: "49.8",
          transactionAmount: "3635.4",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县蒋家桥镇人民政府",
          productName: "祁东县黄花源大米25kg/袋",
          count: "1",
          unitPrice: "115",
          transactionAmount: "115",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县双桥镇人民政府",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "87",
          unitPrice: "115",
          transactionAmount: "10005",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县公安局机关",
          productName: "祁东县喜百岁山茶籽油1L/瓶",
          count: "95",
          unitPrice: "158",
          transactionAmount: "15010",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县步云桥镇中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "87",
          unitPrice: "115",
          transactionAmount: "10005",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县市场监督管理局",
          productName: "金泰-生态香米小袋10斤",
          count: "250",
          unitPrice: "60",
          transactionAmount: "15000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县归阳镇人民政府",
          productName: "祁东县黄花源稻花香米5kg/包",
          count: "83",
          unitPrice: "65.8",
          transactionAmount: "5461.4",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县民政局机关",
          productName: "粒粒馋 油粘米25kg 产地湖南衡阳",
          count: "50",
          unitPrice: "130",
          transactionAmount: "6500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县民政局机关",
          productName: "祁东粒粒馋青蛙米10kg",
          count: "50",
          unitPrice: "70",
          transactionAmount: "3500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县金桥镇人民政府",
          productName: "祁东县 金泰-桃香米籼米大袋50斤",
          count: "84",
          unitPrice: "120",
          transactionAmount: "10080",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县石亭子镇梅塘中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "45",
          unitPrice: "115",
          transactionAmount: "5175",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县城连墟乡人民政府",
          productName: "金泰-生态香米小袋10斤",
          count: "220",
          unitPrice: "60",
          transactionAmount: "13200",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民医院",
          productName: "祁东县黄花源稻花香米5kg/包",
          count: "152",
          unitPrice: "65.8",
          transactionAmount: "10001.6",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县洪桥街道洪桥中学",
          productName: "金泰-红色香粘籼米大袋50斤",
          count: "272",
          unitPrice: "110",
          transactionAmount: "29920",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县财政局",
          productName: "金泰-生态香米小袋10斤",
          count: "250",
          unitPrice: "60",
          transactionAmount: "15000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县太和堂镇人民政府",
          productName: "金泰-红色香粘籼米大袋50斤",
          count: "246",
          unitPrice: "110",
          transactionAmount: "27060",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县第五人民医院",
          productName: "祁东粒粒馋浓米香5kg",
          count: "130",
          unitPrice: "80",
          transactionAmount: "10400",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县石亭子镇人民政府",
          productName: "金泰-生态香米小袋10斤",
          count: "201",
          unitPrice: "60",
          transactionAmount: "12060",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县河洲镇第二中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "90",
          unitPrice: "115",
          transactionAmount: "10350",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县人民政府白鹤街道办事处",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "430",
          unitPrice: "35",
          transactionAmount: "15050",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县城连墟乡中心学校",
          productName: "祁东县 金泰-桃香米籼米大袋50斤",
          count: "84",
          unitPrice: "120",
          transactionAmount: "10080",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县水利局",
          productName: "金泰-生态香米小袋10斤",
          count: "167",
          unitPrice: "60",
          transactionAmount: "10020",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县公路建设养护中心",
          productName: "祁东县黄花源香软粘米10kg/袋",
          count: "20",
          unitPrice: "60",
          transactionAmount: "1200",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县公路建设养护中心",
          productName: "祁东县黄花源香软粘米15kg/袋",
          count: "90",
          unitPrice: "90",
          transactionAmount: "8100",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县公路建设养护中心",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "20",
          unitPrice: "35",
          transactionAmount: "700",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县职业中等专业学校",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "435",
          unitPrice: "115",
          transactionAmount: "50025",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县交通警察大队",
          productName: "金泰-生态香米小袋10斤",
          count: "203",
          unitPrice: "60",
          transactionAmount: "12180",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳师范学院祁东附属中学",
          productName: "金泰-红色香粘籼米大袋50斤",
          count: "800",
          unitPrice: "110",
          transactionAmount: "88000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县砖塘镇中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "45",
          unitPrice: "115",
          transactionAmount: "5175",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县马杜桥乡人民政府",
          productName: "祁东县黄花源香软粘米15kg/袋",
          count: "56",
          unitPrice: "90",
          transactionAmount: "5040",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县白鹤街道白鹤中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "100",
          unitPrice: "115",
          transactionAmount: "11500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县第二人民医院",
          productName: "金泰-生态香米小袋10斤",
          count: "84",
          unitPrice: "60",
          transactionAmount: "5040",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县机关事务和接待中心",
          productName: "祁东县 金泰-青蛙王子籼米小袋20斤",
          count: "200",
          unitPrice: "75",
          transactionAmount: "15000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县归阳镇人民政府",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "40",
          unitPrice: "115",
          transactionAmount: "4600",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县双桥镇人民政府",
          productName: "祁东粒粒馋浓米香5kg",
          count: "125",
          unitPrice: "80",
          transactionAmount: "10000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县官家嘴镇中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "100",
          unitPrice: "115",
          transactionAmount: "11500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县过水坪镇人民政府",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "20",
          unitPrice: "35",
          transactionAmount: "700",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县过水坪镇人民政府",
          productName: "祁东县黄花源香软粘米10kg/袋",
          count: "20",
          unitPrice: "60",
          transactionAmount: "1200",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县过水坪镇人民政府",
          productName: "祁东县黄花源香软粘米15kg/袋",
          count: "90",
          unitPrice: "90",
          transactionAmount: "8100",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "湖南省祁东县第一中学",
          productName: "祁东县 金泰-状元米籼米大袋50斤",
          count: "435",
          unitPrice: "115",
          transactionAmount: "50025",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "湖南省祁东县第一中学",
          productName: "祁东粒粒馋晚籼米25KG",
          count: "261",
          unitPrice: "115",
          transactionAmount: "30015",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县双桥镇中学",
          productName: "金泰-红色香粘籼米大袋50斤",
          count: "91",
          unitPrice: "110",
          transactionAmount: "10010",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县人民政府永昌街道办事处",
          productName: "祁东县 金泰-青蛙王子籼米小袋20斤",
          count: "200",
          unitPrice: "75",
          transactionAmount: "15000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县鸟江镇丁字中学",
          productName: "祁东县 金泰-桃香米籼米大袋50斤",
          count: "84",
          unitPrice: "120",
          transactionAmount: "10080",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县人民政府洪桥街道办事处",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "430",
          unitPrice: "35",
          transactionAmount: "15050",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县农业农村局机关",
          productName: "祁东县黄花源再生稻5kg/包",
          count: "302",
          unitPrice: "49.8",
          transactionAmount: "15039.6",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县风石堰镇毛坪中学",
          productName: "金泰-红色香粘籼米大袋50斤",
          count: "91",
          unitPrice: "110",
          transactionAmount: "10010",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县灵官镇中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "87",
          unitPrice: "115",
          transactionAmount: "10005",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县蒋家桥镇小坪中学",
          productName: "金泰-红色香粘籼米大袋50斤",
          count: "100",
          unitPrice: "110",
          transactionAmount: "11000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县蒋家桥镇第一中学",
          productName: "祁东粒粒馋晚籼米25KG",
          count: "88",
          unitPrice: "115",
          transactionAmount: "10120",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县黄土铺镇人民政府",
          productName: "祁东县黄花源开袋即食红薯片260g/包",
          count: "1",
          unitPrice: "15",
          transactionAmount: "15",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县黄土铺镇人民政府",
          productName: "祁东县喜百岁玉米胚芽油5L/桶",
          count: "100",
          unitPrice: "82.8",
          transactionAmount: "8280",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县黄土铺镇人民政府",
          productName: "祁东县黄花源香软粘米15kg/袋",
          count: "19",
          unitPrice: "90",
          transactionAmount: "1710",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县教育局",
          productName: "祁东县 金泰-桃香米籼米大袋50斤",
          count: "125",
          unitPrice: "120",
          transactionAmount: "15000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县步云桥镇坪塘中学",
          productName: "祁东县黄花源大米25kg/袋",
          count: "44",
          unitPrice: "115",
          transactionAmount: "5060",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县风石堰镇紫冲中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "150",
          unitPrice: "115",
          transactionAmount: "17250",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县思源实验学校",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "300",
          unitPrice: "115",
          transactionAmount: "34500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县第二中学",
          productName: "金泰-红色香粘籼米大袋50斤",
          count: "762",
          unitPrice: "105",
          transactionAmount: "80010",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县太和堂镇中学",
          productName: "祁东县黄花源香软粘米10kg/袋",
          count: "166",
          unitPrice: "60",
          transactionAmount: "9960",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县太和堂镇中学",
          productName: "祁东县黄花源再生稻5kg/包",
          count: "1",
          unitPrice: "49.8",
          transactionAmount: "49.8",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县育贤中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "700",
          unitPrice: "115",
          transactionAmount: "80500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县河洲镇中心学校",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "100",
          unitPrice: "115",
          transactionAmount: "11500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县黄土铺镇三星中学",
          productName: "金泰-红色香粘籼米大袋50斤",
          count: "50",
          unitPrice: "105",
          transactionAmount: "5250",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县黄土铺镇中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "200",
          unitPrice: "115",
          transactionAmount: "23000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县灵官镇大同市中学",
          productName: "祁东县黄花源大米25kg/袋",
          count: "87",
          unitPrice: "115",
          transactionAmount: "10005",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县太和堂镇罗口町中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "91",
          unitPrice: "115",
          transactionAmount: "10465",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县白地市镇枫树山中学",
          productName: "祁东县黄花源香软粘米10kg/袋",
          count: "10",
          unitPrice: "60",
          transactionAmount: "600",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县白地市镇枫树山中学",
          productName: "祁东县黄花源香软粘米10kg/袋",
          count: "10",
          unitPrice: "60",
          transactionAmount: "600",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县白地市镇枫树山中学",
          productName: "祁东县黄花源香软粘米15kg/袋",
          count: "100",
          unitPrice: "90",
          transactionAmount: "9000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县石亭子镇中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "45",
          unitPrice: "115",
          transactionAmount: "5175",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县白地市镇枫树山中学",
          productName: "祁东县黄花源香软粘米10kg/袋",
          count: "20",
          unitPrice: "60",
          transactionAmount: "1200",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县白地市镇枫树山中学",
          productName: "祁东县黄花源香软粘米15kg/袋",
          count: "90",
          unitPrice: "90",
          transactionAmount: "8100",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县白地市镇枫树山中学",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "20",
          unitPrice: "35",
          transactionAmount: "700",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "石门县次伦红商务绿茶250g",
          count: "5",
          unitPrice: "88",
          transactionAmount: "440",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "石门县次伦红商务红茶250g",
          count: "3",
          unitPrice: "100",
          transactionAmount: "300",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县过水坪镇福炎中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "90",
          unitPrice: "115",
          transactionAmount: "10350",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县粮市镇中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "100",
          unitPrice: "115",
          transactionAmount: "11500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县风石堰镇中学",
          productName: "祁东县黄花源香软粘米15kg/袋",
          count: "90",
          unitPrice: "90",
          transactionAmount: "8100",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县风石堰镇中学",
          productName: "祁东县黄花源香软粘米10kg/袋",
          count: "20",
          unitPrice: "60",
          transactionAmount: "1200",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县风石堰镇中学",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "20",
          unitPrice: "35",
          transactionAmount: "700",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "祁东县黄花源干黄花菜600g礼盒装/份",
          count: "5",
          unitPrice: "108",
          transactionAmount: "540",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "祁东县喜百岁山茶籽油3L/瓶",
          count: "3",
          unitPrice: "398",
          transactionAmount: "1194",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县砖塘镇包圣殿中学",
          productName: "金泰-生态香米小袋10斤",
          count: "135",
          unitPrice: "58",
          transactionAmount: "7830",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县太和堂镇罗口町中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "87",
          unitPrice: "115",
          transactionAmount: "10005",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县粮市镇中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "100",
          unitPrice: "115",
          transactionAmount: "11500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县河洲镇中心学校",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "100",
          unitPrice: "115",
          transactionAmount: "11500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县公安局机关",
          productName: "祁东县黄花源干黄花菜600g礼盒装/份",
          count: "17",
          unitPrice: "108",
          transactionAmount: "1836",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县公安局机关",
          productName: "祁东县喜百岁山茶籽油3L/瓶",
          count: "20",
          unitPrice: "398",
          transactionAmount: "7960",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县公安局机关",
          productName: "祁东县喜百岁富硒山泉水460mL*24瓶/箱",
          count: "150",
          unitPrice: "35",
          transactionAmount: "5250",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县石亭子镇中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "139",
          unitPrice: "115",
          transactionAmount: "15985",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县官家嘴镇中学",
          productName: "祁东县 金泰-状元米籼米大袋50斤",
          count: "200",
          unitPrice: "117",
          transactionAmount: "23400",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳师范学院祁东附属中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "600",
          unitPrice: "110",
          transactionAmount: "66000",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县粮市镇中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "100",
          unitPrice: "115",
          transactionAmount: "11500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县风石堰镇紫冲中学",
          productName: "金泰-绿色香粘籼米大袋50斤",
          count: "100",
          unitPrice: "115",
          transactionAmount: "11500",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "祁东县喜百岁山茶籽油1L/瓶",
          count: "6",
          unitPrice: "138",
          transactionAmount: "828",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "祁东县人民检察院",
          productName: "祁东县黄花源干黄花菜600g礼盒装/份",
          count: "3",
          unitPrice: "108",
          transactionAmount: "324",
        },
        {
          prefecture: "祁东县",
          purchasingAgent: "衡阳市祁东县石亭子镇人民政府",
          productName: "金泰-生态香米小袋10斤",
          count: "205",
          unitPrice: "58",
          transactionAmount: "11890",
        },
      ],
      yuslist: [
        {
          id: "1",
          enterprise: "湖南吉祥食品有限公司",
          principal: "谢群亚",
          photo: "15377474777",
          settleType: "企业入驻",
        },
        {
          id: "2",
          enterprise: "湖南灵官枣园村电子商务有限公司",
          principal: "李方卿",
          photo: "13378945952",
          settleType: "企业入驻",
        },
        {
          id: "3",
          enterprise: "湖南广汇油茶有限责任公司",
          principal: "江青平",
          photo: "13607809994",
          settleType: "企业入驻",
        },
        {
          id: "4",
          enterprise: "祁东壹零肆肆网络科技有限责任公司",
          principal: "肖聪",
          photo: "15581685838",
          settleType: "企业入驻",
        },
        {
          id: "5",
          enterprise: "湖南格律诗生态农场有限公司",
          principal: "王方星",
          photo: "17347098888",
          settleType: "企业入驻",
        },
        {
          id: "6",
          enterprise: "祁东龙耕农业发展有限公司",
          principal: "彭向前",
          photo: "13618445806",
          settleType: "企业入驻",
        },
        {
          id: "7",
          enterprise: "祁东尚品会商贸有限公司",
          principal: "刘明志",
          photo: "17347347327",
          settleType: "企业入驻",
        },
        {
          id: "8",
          enterprise: "湖南喷天香生态农业科技发展有限公司",
          principal: "肖春雷",
          photo: "18397781919",
          settleType: "企业入驻",
        },
        {
          id: "9",
          enterprise: "祁东县湘里美味电子商务有限责任公司",
          principal: "彭高峰",
          photo: "18973430858",
          settleType: "企业入驻",
        },
        {
          id: "10",
          enterprise: "祁东讯联网络科技有限公司",
          principal: "肖小林",
          photo: "15367059990",
          settleType: "企业入驻",
        },
        {
          id: "11",
          enterprise: "谭老三土特产",
          principal: "谭耀国",
          photo: "13570822052",
          settleType: "企业入驻",
        },
        {
          id: "12",
          enterprise: "祁东源生味电子商务有限公司",
          principal: "官橙宝",
          photo: "15386060307",
          settleType: "企业入驻",
        },
        {
          id: "13",
          enterprise: "祁东东扬纸箱有限公司",
          principal: "陈超扬",
          photo: "13757077230",
          settleType: "企业入驻",
        },
        {
          id: "14",
          enterprise: "湖南养生知宝食品有限责任公司",
          principal: "陈艳芳",
          photo: "18397795721",
          settleType: "企业入驻",
        },
        {
          id: "15",
          enterprise: "祁东县忆年糍粑食品铺",
          principal: "周争荣",
          photo: "18169289936",
          settleType: "企业入驻",
        },
        {
          id: "16",
          enterprise: "祁东黄花电子商务有限公司",
          principal: "伍路平",
          photo: "15386015855",
          settleType: "企业入驻",
        },
        {
          id: "17",
          enterprise: "湖南省中黄农业科技发展有限公司",
          principal: "周红军",
          photo: "13317473633",
          settleType: "企业入驻",
        },
        {
          id: "18",
          enterprise: "祁东县琴妹子食品店",
          principal: "李瑶琴",
          photo: "18373442310",
          settleType: "企业入驻",
        },
        {
          id: "19",
          enterprise: "祁东县电子商务协会",
          principal: "李方卿",
          photo: "13378945952",
          settleType: "企业入驻",
        },
        {
          id: "20",
          enterprise: "湖南省农交汇电子商务股份有限公司",
          principal: "谢铁军",
          photo: "15673453333",
          settleType: "企业入驻",
        },
        {
          id: "21",
          enterprise: "湖南龙旺食品有限公司",
          principal: "李海玉",
          photo: "17680266686",
          settleType: "品牌入驻",
        },
        {
          id: "22",
          enterprise: "湖南劲松食品股份有限公司",
          principal: "肖劲松",
          photo: "13974776090",
          settleType: "品牌入驻",
        },
        {
          id: "23",
          enterprise: "湖南创富村电子商务有限公司",
          principal: "欧阳小勇",
          photo: "17607477476",
          settleType: "品牌入驻",
        },
        {
          id: "24",
          enterprise: "湖南御之园食品有限公司",
          principal: "石伟",
          photo: "15973412113",
          settleType: "品牌入驻",
        },
        {
          id: "25",
          enterprise: "湖南黄花电子商务有限公司",
          principal: "黄铁山",
          photo: "15386060618",
          settleType: "品牌入驻",
        },
        {
          id: "26",
          enterprise: "湖南家乡泥生态农业发展有限公司",
          principal: "萧志旺",
          photo: "15873420212",
          settleType: "品牌入驻",
        },
        {
          id: "27",
          enterprise: "湖南新农人电子商务有限公司",
          principal: "管小伟",
          photo: "15211497212",
          settleType: "品牌入驻",
        },
        {
          id: "28",
          enterprise: "湖南有吉食品公司",
          principal: "万基荣",
          photo: "17369387777",
          settleType: "品牌入驻",
        },
        {
          id: "29",
          enterprise: "祁东县农业发展有限公司",
          principal: "郝建民",
          photo: "13786483688",
          settleType: "品牌入驻",
        },
        {
          id: "30",
          enterprise: "湖南味了谁食品有限责任公司",
          principal: "陈剑云",
          photo: "13714588561",
          settleType: "品牌入驻",
        },
        {
          id: "31",
          enterprise: "湖南新丰果业有限公司",
          principal: "李祥勇",
          photo: "15116850022",
          settleType: "品牌入驻",
        },
        {
          id: "32",
          enterprise: "湖南雁隆食品有限责任公司",
          principal: "唐琼",
          photo: "15096073593",
          settleType: "品牌入驻",
        },
        {
          id: "33",
          enterprise: "祁东县聚德电子商务有限公司",
          principal: "谭斌",
          photo: "18873422430",
          settleType: "品牌入驻",
        },
        {
          id: "34",
          enterprise: "祁东县众善福种植养殖合作社",
          principal: "蒋松林",
          photo: "17769345570",
          settleType: "品牌入驻",
        },
        {
          id: "35",
          enterprise: "祁东县双桥粮食购销有限责任公司",
          principal: "黄会计",
          photo: "13975482082",
          settleType: "品牌入驻",
        },
        {
          id: "36",
          enterprise: "祁东县归阳粮食购销有限责任公司",
          principal: "刘建勋",
          photo: "13707479860",
          settleType: "品牌入驻",
        },
        {
          id: "37",
          enterprise: "祁东县银桥枣业农民专业合作社",
          principal: "陈新仁",
          photo: "15386029820",
          settleType: "品牌入驻",
        },
        {
          id: "38",
          enterprise: "祁东县众合种养专业合作社",
          principal: "石知元",
          photo: "18773446308",
          settleType: "品牌入驻",
        },
        {
          id: "39",
          enterprise: "湖南省亿安生态农业发展有限公司",
          principal: "陈莲花",
          photo: "15727452926",
          settleType: "品牌入驻",
        },
        {
          id: "40",
          enterprise: "祁东县星明家庭农场",
          principal: "肖星明",
          photo: "19152366185",
          settleType: "品牌入驻",
        },
        {
          id: "41",
          enterprise: "祁东县湘香生态科技发展有限公司",
          principal: "段平平",
          photo: "17769348727",
          settleType: "品牌入驻",
        },
        {
          id: "42",
          enterprise: "八戒财税",
          principal: "袁诗梅",
          photo: "19974716072",
          settleType: "品牌入驻",
        },
        {
          id: "43",
          enterprise: "雷志伟律师",
          principal: "雷志伟",
          photo: "13237340653",
          settleType: "品牌入驻",
        },
        {
          id: "44",
          enterprise: "祁东很有意思文化创意有限公司",
          principal: "邹波",
          photo: "18974765776",
          settleType: "品牌入驻",
        },
      ],
    };
  },
  components: {
    Head,
    bgAnimateVue,
  },
  computed: {
    scrollOption() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  created() {
    this.getSmartCityInfo();
    window.WIDGET = {
      CONFIG: {
        layout: "1",
        width: "450",
        height: "100",
        background: "5",
        dataColor: "FFFFFF",
        borderRadius: "5",
        city: "CN101250404",
        key: "7820c8586bdf43a596e9316bbc29695f",
      },
    };
    (function (d) {
      var c = d.createElement("link");
      c.rel = "stylesheet";
      c.href =
        "https://widget.qweather.net/standard/static/css/he-standard.css?v=1.4.0";
      var s = d.createElement("script");
      s.src =
        "https://widget.qweather.net/standard/static/js/he-standard.js?v=1.4.0";
      var sn = d.getElementsByTagName("script")[0];
      sn.parentNode.insertBefore(c, sn);
      sn.parentNode.insertBefore(s, sn);
    })(document);
  },
  mounted() {
    // 获取智慧城市信息

    this.init9();
    this.init10();
    this.init11();
    this.init12();
    window.addEventListener("resize", () => {
      this.chart9.resize();
      this.chart10.resize();
      this.chart11.resize();
      this.chart12.resize();
    });
    this.swiper1 = new Swiper(".swiper-container1", {
      effect: "coverflow",
      slidesPerView: 3,
      centeredSlides: true,
      coverflow: {
        rotate: 30,
        stretch: 10,
        depth: 60,
        modifier: 2,
        slideShadows: true,
      },
      speed: 3000,
      autoplay: true,
      loop: true,
    });
    this.swiper2 = new Swiper(".swiper-container2", {
      speed: 3000,
      autoplay: true,
      loop: true,
      slidesPerView: 4,
      spaceBetween: 20,
      // slidesPerColumn: 2,
    });
  },
  methods: {
    // 获取智慧城市信息
    getSmartCityInfo() {
      axios
        .get("/10qdzhcs.json")
        .then(
          (res) => {
            console.log("请求成功了", res.data);

            this.subtitleList = res.data.subtitle;
            this.education = res.data.firstmodule1;
            this.investment = res.data.firstmodule2;
            this.treatment = res.data.firstmodule3;
            this.income = res.data.firstmodule4;
            this.environment = res.data.secondmodule1;
            this.fineAir = res.data.secondmodule2;
            console.log("this.fineAir", this.fineAir);
            this.yearAir = res.data.secondmodule3;
            this.centerInfo = res.data.centermodule;
            this.yearGDP = res.data.fourmoudle1.title;
            this.keyProject = res.data.fourmoudle2.title;
            this.onlineIndustry = res.data.fourmoudle3.title;
            this.countyIncome = res.data.fourmoudle4.title;
            this.workManagement = res.data.fivemodule1;
            this.takeNumber = res.data.fivemodule2;
            this.waitingTime = res.data.fivemodule3;
          },
          (err) => {
            console.log("请求失败了", err.message);
          }
        )
        .catch((error) => {
          console.log(error);
        });
    },

    init9() {
      axios
        .get("/10qdzhcs.json")
        .then(
          (res) => {
            // console.log('请求成功',res.data);
            const chart9Year = res.data.fourmoudle1.year;
            const chart9Data = res.data.fourmoudle1.value;
            this.chart9 = Echarts.init(this.$refs.chart9);
            let option = {
              title: {
                text: "单位:万元",
                top: 0,
                right: 0,
                textStyle: {
                  fontSize: nowSize(25),
                  color: "#fff",
                },
              },
              tooltip: {
                trigger: "axis",
                backgroundColor: "rgba(0,0,0,.65)",
                textStyle: {
                  fontSize: nowSize(12),
                  color: "#fff",
                },
                extraCssText: "border:1px solid #3FF5FF",
                axisPointer: {
                  crossStyle: {
                    color: "#fff",
                  },
                },
              },
              toolbox: {
                show: true,
              },
              grid: {
                left: nowSize(5),
                right: nowSize(10),
                bottom: nowSize(5),
                top: nowSize(20),
                containLabel: true,
              },
              xAxis: [
                {
                  type: "category",
                  //boundaryGap: false,
                  // data: ["2018", "2019", "2020", "2021", "2022", "2023"],
                  data: chart9Year,
                  axisPointer: {
                    type: "",
                  },
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: "#fff",
                      fontSize: nowSize(25),
                    },
                    //rotate: '0',
                    interval: 0,
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#023748", //更改坐标轴颜色
                    },
                  },
                  splitLine: {
                    show: false,
                    lineStyle: {
                      color: ["#edf2f8"],
                      width: 1,
                      type: "dashed",
                    },
                  },
                },
              ],
              yAxis: [
                {
                  type: "value",
                  name: "",
                  position: "left",
                  min: 0,
                  interval: 20000,
                  nameTextStyle: {
                    color: "#fff",
                    fontSize: nowSize(25),
                    padding: [0, 0, 0, -20],
                  },
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: "#fff", //更改坐标轴文字颜色
                      fontSize: nowSize(25), //更改坐标轴文字大小
                    },
                    //formatter: '{value}%'
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLine: {
                    show: false,
                    lineStyle: {
                      color: "#023748", //更改坐标轴颜色
                    },
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: ["#023748"],
                      width: 1,
                      type: "solid",
                    },
                  },
                },
              ],

              series: [
                {
                  name: "",
                  type: "bar",
                  stack: "Total",
                  label: {
                    show: true,
                    position: "top",
                    textStyle: {
                      color: "#fff",
                      fontSize: nowSize(25),
                    },
                  },
                  showBackground: false,
                  barWidth: nowSize(20),
                  // data: [
                  //   82688, 88200, 44100, 48510, 49612, 50715, 71662, 48510, 50164,
                  //   51266, 52369, 54574,
                  // ],
                  data: chart9Data,
                  itemStyle: {
                    normal: {
                      barBorderRadius: 0,
                      color: new Echarts.graphic.LinearGradient(0, 1, 0, 0, [
                        {
                          offset: 0,
                          color: "#024570",
                        },
                        {
                          offset: 1,
                          color: "#45F5FF",
                        },
                      ]),
                    },
                  },
                },
              ],
            };
            this.chart9.setOption(option, true);

            this.tootipTimer9 && this.tootipTimer9.clearLoop();
            this.tootipTimer9 = 0;
            this.tootipTimer9 = loopShowTooltip(this.chart9, option, {});
          },
          (err) => {
            console.log("请求失败", err.mesage);
          }
        )
        .catch((error) => {
          console.log(error);
        });
    },
    // 重点项目投资额
    init10() {
      axios
        .get("/10qdzhcs.json")
        .then(
          (res) => {
            // console.log('请求成功',res.data);
            const chart10Month = res.data.fourmoudle2.mounth;
            const chart10Data = res.data.fourmoudle2.value;
            this.chart10 = Echarts.init(this.$refs.chart10);
            let option = {
              title: {
                text: "单位:万元",
                top: 0,
                right: 0,
                textStyle: {
                  fontSize: nowSize(25),
                  color: "#fff",
                },
              },
              tooltip: {
                trigger: "axis",
                backgroundColor: "rgba(0,0,0,.65)",
                textStyle: {
                  fontSize: nowSize(12),
                  color: "#fff",
                },
                extraCssText: "border:1px solid #3FF5FF",
                axisPointer: {
                  crossStyle: {
                    color: "#fff",
                  },
                },
              },
              toolbox: {
                show: true,
              },
              grid: {
                left: nowSize(5),
                right: nowSize(10),
                bottom: nowSize(5),
                top: nowSize(20),
                containLabel: true,
              },
              xAxis: [
                {
                  type: "category",
                  //boundaryGap: false,
                  // data: [
                  //   "1月",
                  //   "2月",
                  //   "3月",
                  //   "4月",
                  //   "5月",
                  //   "6月",
                  //   "7月",
                  //   "8月",
                  //   "9月",
                  //   "10月",
                  //   "11月",
                  //   "12月",],
                  data: chart10Month,
                  axisPointer: {
                    type: "",
                  },
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: "#fff",
                      fontSize: nowSize(25),
                    },
                    //rotate: '0',
                    interval: 0,
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#023748", //更改坐标轴颜色
                    },
                  },
                  splitLine: {
                    show: false,
                    lineStyle: {
                      color: ["#edf2f8"],
                      width: 1,
                      type: "dashed",
                    },
                  },
                },
              ],
              yAxis: [
                {
                  name: "",
                  type: "value",
                  position: "left",
                  min: 0,
                  interval: 50,
                  nameTextStyle: {
                    color: "#fff",
                    fontSize: nowSize(25),
                    padding: [0, 0, 0, -20],
                  },
                  axisLabel: {
                    show: true,
                    // formatter:'{value}元',
                    textStyle: {
                      color: "#fff", //更改坐标轴文字颜色
                      fontSize: nowSize(25), //更改坐标轴文字大小
                    },
                    //formatter: '{value}%'
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLine: {
                    show: false,
                    lineStyle: {
                      color: "#023748", //更改坐标轴颜色
                    },
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: ["#023748"],
                      width: 1,
                      type: "solid",
                    },
                  },
                },
              ],

              series: [
                {
                  name: "",
                  type: "bar",
                  stack: "Total",
                  label: {
                    show: true,
                    position: "top",
                    textStyle: {
                      color: "#fff",
                      fontSize: nowSize(25),
                    },
                  },
                  showBackground: false,
                  barWidth: nowSize(15),
                  // data: [126832, 183202, 169110, 140925,126832, 183202, 169110, 140925,126832, 183202, 169110, 140925],
                  data: chart10Data,
                  itemStyle: {
                    normal: {
                      barBorderRadius: 0,
                      color: new Echarts.graphic.LinearGradient(0, 1, 0, 0, [
                        {
                          offset: 0,
                          color: "#024570",
                        },
                        {
                          offset: 1,
                          color: "#45F5FF",
                        },
                      ]),
                    },
                  },
                },
              ],
            };
            this.chart10.setOption(option, true);

            this.tootipTimer10 && this.tootipTimer10.clearLoop();
            this.tootipTimer10 = 0;
            this.tootipTimer10 = loopShowTooltip(this.chart10, option, {});
          },
          (err) => {
            console.log("请求失败", err.mesage);
          }
        )
        .catch((error) => {
          console.log(error);
        });
    },

    init11() {
      axios
        .get("/10qdzhcs.json")
        .then(
          (res) => {
            // console.log('请求成功',res.data);
            const chart11Month = res.data.fourmoudle3.mounth;
            const chart11Data = res.data.fourmoudle3.value;
            this.chart11 = Echarts.init(this.$refs.chart11);
            let option = {
              title: {
                text: "单位:万元",
                top: 0,
                right: 0,
                textStyle: {
                  fontSize: nowSize(25),
                  color: "#fff",
                },
              },
              tooltip: {
                trigger: "axis",
                backgroundColor: "rgba(0,0,0,.65)",
                textStyle: {
                  fontSize: nowSize(12),
                  color: "#fff",
                },
                extraCssText: "border:1px solid #3FF5FF",
                axisPointer: {
                  crossStyle: {
                    color: "#fff",
                  },
                },
              },
              toolbox: {
                show: true,
              },
              grid: {
                left: nowSize(10),
                right: nowSize(30),
                bottom: nowSize(5),
                top: nowSize(10),
                containLabel: true,
              },
              xAxis: [
                {
                  type: "category",
                  boundaryGap: false,
                  // data: [
                  //   "1月",
                  //   "2月",
                  //   "3月",
                  //   "4月",
                  //   "5月",
                  //   "6月",
                  //   "7月",
                  //   "8月",
                  //   "9月",
                  //   "10月",
                  //   "11月",
                  //   "12月",
                  // ],
                  data: chart11Month,
                  axisPointer: {
                    type: "",
                  },
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: "#fff",
                      fontSize: nowSize(25),
                    },
                    //rotate: '0',
                    interval: 0,
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#023748", //更改坐标轴颜色
                    },
                  },
                  splitLine: {
                    show: false,
                    lineStyle: {
                      color: ["#edf2f8"],
                      width: 1,
                      type: "dashed",
                    },
                  },
                },
              ],
              yAxis: [
                {
                  type: "value",
                  name: "",
                  position: "left",
                  min: 0,
                  //max: 30000,
                  interval: 2000,
                  nameTextStyle: {
                    color: "#fff",
                    fontSize: nowSize(25),
                    padding: [0, 0, 0, -20],
                  },
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: "#fff", //更改坐标轴文字颜色
                      fontSize: nowSize(25), //更改坐标轴文字大小
                    },
                    // formatter: '{value}%'
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLine: {
                    show: true,
                    lineStyle: {
                      color: "#023748", //更改坐标轴颜色
                    },
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      color: ["#023748"],
                      width: 1,
                      type: "solid",
                    },
                  },
                },
              ],

              series: [
                {
                  name: "",
                  type: "line",
                  // data: [
                  //   5073, 6088, 7610, 9639, 4059, 10147, 8117, 5581, 9132, 8625, 2537,
                  // ],
                  data: chart11Data,
                  smooth: true,
                  symbolSize: 1, //折线点的大小
                  itemStyle: {
                    normal: {
                      color: "#FD9D20", //折线点的颜色
                      borderWidth: 1,
                      lineStyle: {
                        color: "#FD9D20", //折线的颜色
                      },
                      areaStyle: {
                        color: new Echarts.graphic.LinearGradient(0, 1, 0, 0, [
                          {
                            offset: 0,
                            color: "rgba(235,157,32,0)",
                          },
                          {
                            offset: 1,
                            color: "rgba(235,157,32,.6)",
                          },
                        ]),
                      },
                    },
                  },
                },
              ],
            };
            this.chart11.setOption(option, true);

            this.tootipTimer11 && this.tootipTimer11.clearLoop();
            this.tootipTimer11 = 0;
            this.tootipTimer11 = loopShowTooltip(this.chart11, option, {});
          },
          (err) => {
            console.log("请求失败", err.mesage);
          }
        )
        .catch((error) => {
          console.log(error);
        });
    },

    init12() {
      axios
        .get("/10qdzhcs.json")
        .then(
          (res) => {
            console.log("请求成功", res.data);
            this.chart12 = Echarts.init(this.$refs.chart12);

            const chartData = res.data.fourmoudle4.data;
            const sum = chartData.reduce((per, cur) => per + cur.value, 0);
            let option = {
              title: {
                text: "{a|财政收入}\n\n{b|" + sum + "万元}",
                top: "center",
                textStyle: {
                  rich: {
                    a: {
                      fontSize: nowSize(20),
                      padding: [0, 0, 0, nowSize(110)],
                      color: "#fff",
                      lineHeight: 1,
                      fontFamily: "YouSheBiaoTiHei",
                    },
                    b: {
                      fontSize: nowSize(20),
                      padding: [nowSize(10), 0, 0, nowSize(110)],
                      color: "#45F5FF",
                      lineHeight: 1,
                      fontFamily: "YouSheBiaoTiHei",
                    },
                  },
                },
              },
              tooltip: {
                trigger: "item",
                backgroundColor: "rgba(0,0,0,.65)",
                textStyle: {
                  fontSize: nowSize(12),
                  color: "#fff",
                },
                extraCssText: "border:1px solid #3FF5FF",
                axisPointer: {
                  crossStyle: {
                    color: "#fff",
                  },
                },
              },
              grid: {
                left: "0",
                right: "0",
                bottom: "0",
                top: "0",
                containLabel: true,
              },
              legend: {
                x: "right",
                y: "center",
                orient: "vertial",
                icon: "rect",
                itemWidth: nowSize(28),
                itemHeight: nowSize(20),
                textStyle: {
                  color: "#fff",
                  fontSize: nowSize(16),
                  lineHeight: nowSize(30),
                },
                itemGap: nowSize(15),
                formatter: (name) => {
                  const item = chartData.find((i) => {
                    return i.name === name;
                  });
                  const p = ((item.value / sum) * 100).toFixed(0);
                  const value = item.value;
                  return "{name|" + name + "}" + "{percent|" + p + "%}"; //+"{value|" +value +"万元}"
                },
                textStyle: {
                  rich: {
                    name: {
                      fontSize: nowSize(30),
                      width: nowSize(150),
                      height: nowSize(20),
                      padding: [0, 0, 0, 5],
                      color: "#fff",
                    },
                    // value: {
                    //   fontSize: nowSize(30),
                    //   width: nowSize(100),
                    //   height: nowSize(20),
                    //   color: "#45F5FF",
                    // },
                    percent: {
                      fontSize: nowSize(30),
                      width: nowSize(110),
                      height: nowSize(20),
                      color: "#45F5FF",
                    },
                  },
                },
              },
              color: ["rgb(86,230,215)", "rgb(255,233,156)", "rgb(210,61,226)"],
              series: [
                {
                  name: "",
                  type: "pie",
                  radius: ["58%", "61%"], //75% 78%
                  center: ["30%", "51%"],
                  avoidLabelOverlap: false,
                  hoverAnimation: true,
                  label: {
                    normal: {
                      show: false,
                    },
                  },
                  itemStyle: {
                    borderRadius: 0,
                    borderColor: "#fff",
                    borderWidth: 0,
                  },
                  labelLine: {
                    show: false,
                  },
                  data: chartData,
                },
                {
                  type: "pie",
                  name: "内层细圆环",
                  radius: ["45%", "48%"], //55% 58%
                  center: ["30%", "51%"],
                  hoverAnimation: false,
                  clockWise: true,
                  itemStyle: {
                    normal: {
                      color: "#178ac9",
                    },
                  },
                  tooltip: {
                    show: false,
                  },
                  label: {
                    show: false,
                  },
                  data: [1],
                },
              ],
            };
            this.chart12.setOption(option, true);

            this.tootipTimer12 && this.tootipTimer12.clearLoop();
            this.tootipTimer12 = 0;
            this.tootipTimer12 = loopShowTooltip(this.chart12, option, {});
          },
          (err) => {
            console.log("请求失败", err.mesage);
          }
        )
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
  <style scoped>
.page {
  background: url(https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/zhihuichengshi_bg_one.gif)
    no-repeat center;
  background-size: 100% 100%;
  background-color: #0a224b;
}
.scroll-list .row-t {
  text-align: center;
}
.scroll-list .row div {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* .mod1 {
    height: 35%;
    margin-bottom: 1%;
  } */
.scrollbox {
}
.scroll-list .scrollbb {
  margin-top: 20px;
}
.scroll-list .linebg {
  height: 100%;
}
.mod2 {
  height: 30%;
  margin-bottom: 3%;
  /*  margin-bottom: 1%; */
}
.mod3 {
  height: 30%;
}
.mod4 {
  height: 55%;
}
.scroll-list .row {
  text-align: center;
  line-height: 38px;
}
.scroll-list .row div:nth-child(1) {
  text-align: left;
}
/* @media (min-width: 3000px) {
    .mod4 {
      height: 55%;
    }
  } */

.mod6 {
  height: 40%;
}

.mod1 .detail {
  width: 100%;
  /* display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 10px;
    grid-template-rows: 1fr 1fr; */
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}
.mod1 .chart {
  height: calc(90% - 45px);
}
.mod2 .detail {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  height: 99%;
}

.mod2 .col {
  width: 50%;
  display: flex;
  flex-direction: column;
  height: 40%;
}
.mod2 .col:nth-child(3) {
  height: 60%;
}
.mod2 .col:nth-child(4) {
  height: 60%;
}
.mod2 .chart {
  flex: 1;
}
/deep/.mod2 .chart div:nth-child(1) {
  height: 100% !important;
}
/deep/.mod2 .chart div canvas {
  height: 100% !important;
}
.mod2 .taglist {
  margin-left: -15px;
  display: flex;
  flex-wrap: wrap;
}
.mod2 .taglist .tag {
  padding: 0 5px;
  margin-left: 15px;
  border-radius: 16px;
  line-height: 40px;
  font-size: 16px;
  color: #fff;
  margin-bottom: 15px;
}
.mod2 .taglist .tag.blue {
  box-shadow: inset 0 0 5px 2px #0067ce;
  border: 1px solid #0067ce;
}
.mod2 .taglist .tag.org {
  box-shadow: inset 0 0 5px 2px #fd9d20;
  border: 1px solid #c98e17;
}
.mod2 .taglist .tag.green {
  box-shadow: inset 0 0 5px 2px #05eb89;
  border: 1px solid #17c99c;
}

.mod2 .col:nth-child(3) {
  /* margin-top: -1%;
    height: 60%; */
}
.mod2 .col:nth-child(4) {
  /* margin-top: -1%;
    height: 60%; */
}

.mod2 .b-smtit .smwz {
  font-size: 12px;
}
.mod2 .w-type {
  color: #fff;
}
.mod3 .swiper-container.swiper-container1 {
  width: 100%;
}
.mod3 .swiper-container.swiper-container1 .swiper-slide {
  width: 250px;
  height: 150px;
}

.con-c {
  position: relative;
}
.cen-list {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
}
.cen-list .item {
  text-align: center;
  max-width: 17%;
  position: relative;
}
.cen-list .title {
  font-size: 22px;
  color: #45f5ff;
  font-family: "RuiZiZhenYan";
  margin-bottom: 8px;
}
.cen-list .txt {
  font-size: 16px;
  color: #fff;
  line-height: 1.5;
  margin-bottom: 10px;
}
.cen-list .tag {
  display: inline-block;
  vertical-align: middle;
  padding: 0 10px;
  min-width: 80px;
  text-align: center;
  line-height: 30px;
  text-align: center;
  box-shadow: inset 0 0 5px 2px #05eb89;
  border: 1px solid #17c99c;
  font-size: 16px;
  color: #17c99c;
  border-radius: 18px;
  margin-bottom: 10px;
}
.cen-list .line {
  background: linear-gradient(180deg, #45feff 0%, rgba(0, 66, 197, 0.15) 100%);
  border-radius: 8px;
  width: 5px;
  height: 280px;
  margin: 0 auto;
  position: relative;
}
.cen-list .line::before {
  content: "";
  position: absolute;
  height: 10px;
  width: 5px;
  background: linear-gradient(to top, transparent, #45feff);
  animation: clipAnimate 3s linear infinite;
  box-shadow: 0px 0px 17px 5px #45feff;
  bottom: 0;
  left: 0;
}

@keyframes clipAnimate {
  0% {
    bottom: 0px;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    bottom: 270px;
  }
}

.cen-list .circle {
  position: absolute;
  transform: rotateX(260deg);
  left: 50%;
  bottom: 0;
}
.cen-list .circle > div {
  position: absolute;
  left: -90px;
  bottom: 0;
  width: 180px;
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cen-list .circle > div::after {
  content: "";
  border-radius: 50%;
  animation: ripple 4s linear infinite;
}

.cen-list .item1 {
  margin-bottom: 18%;
}
.cen-list .item2 {
  margin-bottom: 34%;
}
.cen-list .item3 {
  margin-bottom: 28%;
}
.cen-list .item4 {
  margin-bottom: 10%;
}
.cen-list .item5 {
  margin-bottom: 35%;
}
.cen-list .item6 {
  margin-bottom: 18%;
}

.cen-list .circle .w1::after {
  animation-delay: 0s;
}
.cen-list .circle .w2::after {
  animation-delay: 1s;
}
.cen-list .circle .w3::after {
  animation-delay: 2s;
}
.cen-list .circle .w4::after {
  animation-delay: 3s;
}

@keyframes ripple {
  0% {
    opacity: 1;
    width: 0rem;
    height: 0rem;
    background: rgba(0, 66, 197, 0.6);
  }
  to {
    opacity: 0;
    width: 180px;
    height: 180px;
    background: rgba(0, 66, 197, 0.6);
  }
}

.mod4 .detail {
  width: 100%;
  /* display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
    grid-template-rows: 1fr 2fr; */
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.mod4 .col {
  /* height: 100%; */
  /* margin-top: 10%; */
  height: 45%;
  width: 50%;
}
.mod4 .chart {
  margin-top: 10px;
  height: calc(100% - 40px);
}

.mod6 {
}

.bottom-bg {
  position: absolute;
  z-index: 1;
  margin-top: -10px;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 15%;
}

.mod6 .swiper-container2 {
  /* margin-top: 50px; */
  width: 100%;
}
.mod6 .swiper-container2 .swiper-slide img {
  width: 100%;
  /* height: 50%; */
  height: 180px;
  /* height: 50%; */
}
/deep/.mod6 .swiper-container-multirow > .swiper-wrapper {
  flex-wrap: nowrap;
}
/deep/.wv-n-h-col-10 {
  display: flex !important;
}
/deep/div.wv-n-h-now-img > img {
  width: 1.2em;
  margin: 1em 1em 0.2em 0;
}
/deep/.wv-n-h-now-content {
  display: flex !important;
}
/deep/.wv-n-h-now-txt {
  display: flex;
  margin-top: 1em;
  margin-left: 0.5em;
  width: 100%;
  justify-content: space-between;
}
.iesjjs {
  overflow: hidden;
}
/deep/#he-plugin-standard {
  width: 100% !important;
  height: auto !important;
}
/* 祁东 小于2560 */
@media screen and (max-width: 2560px) {
  .page {
    background: url(https://video-1316200666.cos.ap-guangzhou.myqcloud.com/hunan/hengyang/photo/zhihuichengshi_bg_two.gif)
      no-repeat center;
    background-size: 100% 100%;
    background-color: #0a224b;
  }
  .mod2 .col:nth-child(1) {
    width: 100%;
  }
  .mod2 .col:nth-child(2) {
    display: none;
  }
  .cen-list .line {
    height: 480px;
  }
  @keyframes clipAnimate {
    0% {
      bottom: 0px;
    }
    10% {
      opacity: 1;
    }
    90% {
      opacity: 1;
    }
    100% {
      bottom: 470px;
    }
  }
}
.mod1 {
  height: 32%;
  margin-bottom: 3%;
}
.b-container .con-l {
  /* justify-content: space-between; */
}
</style>